<script setup>
import Header from './Header.vue';
import Footer from './Footer.vue';
import BackgroundLayer from '@/components/BackgroundLayer.vue';
</script>

<template>
  <div class="min-h-screen pt-[60px] relative" style="background: #f6fcff">
    <!-- Background Gradient -->
    <BackgroundLayer />

    <!-- Header Section -->
    <Header />

    <!-- Main Content -->
    <div class="container mx-auto px-4 py-24 md:py-32 relative z-10">
      <div class="max-w-3xl mx-auto">
        <div class="text-center">
          <div
            class="rounded-[16px] p-12 md:p-16 transition-all duration-300"
            style="
              background: rgba(255, 255, 255, 0.3);
              box-shadow:
                0px 4px 40px rgba(0, 0, 0, 0.1),
                inset 0px 1px 1px #ffffff;
            "
          >
            <h1 class="text-[8rem] sm:text-[10rem] font-thin text-black mb-8">404</h1>
            <h2 class="text-[40px] font-normal text-black mb-4">
              {{ $t('notFound.title') }}
            </h2>
            <p class="text-[1.125rem] text-black/60 max-w-2xl mx-auto font-light mb-8">
              {{ $t('notFound.description') }}
            </p>
            <router-link
              to="/"
              class="inline-block text-white px-8 py-3 rounded-[16px] font-medium transition-all duration-200 shadow-sm hover:shadow-md"
              style="background: rgba(0, 0, 0, 0.9)"
            >
              {{ $t('notFound.goHome') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Section -->
    <Footer class="relative z-10" />
  </div>
</template>
